import { render, staticRenderFns } from "./popup-choose-order.vue?vue&type=template&id=1b9e2182&scoped=true"
import script from "./popup-choose-order.vue?vue&type=script&lang=js"
export * from "./popup-choose-order.vue?vue&type=script&lang=js"
import style0 from "./popup-choose-order.vue?vue&type=style&index=0&id=1b9e2182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e2182",
  null
  
)

export default component.exports